var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('IconFont',{staticStyle:{"font-size":"300px"},attrs:{"type":"icon-icon-404"}}),_c('Logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }